import { useQuery } from "@tanstack/react-query";
import type { InferResponseType } from "hono";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

const adCampaignsReq = client.merchant[":merchantId"].product[":productId"]["ad-campaigns"].$get;
export type ProductAdCampaignsResponse = InferResponseType<typeof adCampaignsReq>;

export const useProducts = (search?: string) => {
  const scope = useScopedMerchantClient();
  return useQuery({
    queryKey: ["products", scope.merchantId, scope.workspaceId, search],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].product.$get({
            param: scope.param,
            query: { search },
          })
        : await client.merchant[":merchantId"].product.$get({
            param: scope.param,
            query: { search },
          });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!scope.merchantId,
  });
};

export const useProductAdCampaigns = (productId: string) => {
  const scope = useScopedMerchantClient();
  return useQuery({
    queryKey: ["products", scope.merchantId, scope.workspaceId, productId, "ad-campaigns"],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].product[":productId"]["ad-campaigns"].$get({
            param: { ...scope.param, productId },
          })
        : await client.merchant[":merchantId"].product[":productId"]["ad-campaigns"].$get({
            param: { ...scope.param, productId },
          });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!scope.merchantId && !!productId,
  });
};
